import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { castDraft } from "immer";

import { SyncStoreID } from "../../models/nominals";
import { defaults } from "./defaults";
import { StoreSearchFilters } from "./models";
import { loadClosestStores } from "./thunks";

export const retailSlice = createSlice({
    name: "retail",
    initialState: defaults,
    reducers: {
        updateStoreFilters: (
            state,
            action: PayloadAction<Partial<StoreSearchFilters>>,
        ) => {
            state.storeFilters = castDraft({
                ...state.storeFilters,
                ...action.payload,
            });
        },

        setFocusedStore: (
            state,
            action: PayloadAction<{
                externalID: SyncStoreID | null;
            }>,
        ) => {
            state.focusedStoreID = action.payload.externalID;
        },

        setLoadingStores: (state, action: PayloadAction<boolean>) => {
            state.isLoadingStores = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadClosestStores.pending, (state) => {
                state.isLoadingStores = true;
            })
            .addCase(loadClosestStores.fulfilled, (state, action) => {
                state.isLoadingStores = false;
                // Sort stores by distance
                const sortedStores = [...action.payload.stores].sort((a, b) => {
                    if (
                        a.distance === b.distance ||
                        !a.distance ||
                        !b.distance
                    ) {
                        return 0;
                    }
                    return a.distance > b.distance ? 1 : -1;
                });
                state.stores = castDraft(sortedStores);
                if (action.payload.loadKey) {
                    state.storesLoadedKey = action.payload.loadKey;
                }
            })
            .addCase(loadClosestStores.rejected, (state) => {
                state.isLoadingStores = false;
            });
    },
});

export const { updateStoreFilters, setFocusedStore, setLoadingStores } =
    retailSlice.actions;
